import './App.css';
import 'bootstrap';
import Header from '../header/Header';
import Footer from '../footer/Footer';
import Home from '../home/Home';
import PaginatedNews from '../news/PaginatedNews';
import NewsDetail from '../newsDetail/NewsDetail';
import Calendars from '../calendars/Calendars';
import Protocols from '../protocols/Protocols';
import Documents from '../documents/Documents';
import Information from '../information/Information';
import History from '../history/History';
import { Routes, Route } from 'react-router-dom';

function App() {
  return (
    <div className="d-flex flex-column app__wrapper">
      <div className="app__content">
        <Header />
        <main className="main">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="news" element={<PaginatedNews />} />
            <Route path="news/:id" element={<NewsDetail />} />
            <Route path="calendars" element={<Calendars />} />
            <Route path="protocols" element={<Protocols />} />
            <Route path="documents" element={<Documents />} />
            <Route path="information" element={<Information />} />
            <Route path="history" element={<History />} />
          </Routes>
        </main>
      </div>
      <div className="app__footer">
        <Footer />
      </div>
    </div>
  );
}

export default App;